export default __webpack_public_path__ + "static/media/690.81b89dd0.svg";